import { Flex, Image, Text } from "@fluentui/react-northstar";

import { getColorSchemeImg } from "../utils/getColorSchemeImg";
import { useErrorPanelStyles } from "./useErrorPanelStyles";
import { ErrorPanelProps, ErrorPanelType } from "./ErrorPanel.types";

export function ErrorPanel({
  title,
  imgProps,
  description,
  truncateDescription,
  imgColorScheme = "light",
  type = ErrorPanelType.GenericError,
}: ErrorPanelProps) {
  const { container, imgStyles, descriptionStyles, titleStyles } =
    useErrorPanelStyles();

  const image = getColorSchemeImg(type, imgColorScheme);

  return (
    <Flex
      fill
      column
      as="main"
      vAlign="center"
      hAlign="center"
      gap="gap.medium"
      styles={container}
    >
      <Flex vAlign="center" hAlign="center">
        <Image
          data-testid={`${image}Image`}
          fluid
          styles={imgStyles}
          src={`/assets/ui-error-panel/images/${image}.svg`}
          {...imgProps}
        />
      </Flex>
      {title && (
        <Text
          content={<>{title}</>}
          styles={titleStyles}
          weight="bold"
          size="large"
          data-testid="errorPanelTitle"
        />
      )}
      {description && (
        <Text
          truncated={truncateDescription}
          title={description}
          styles={descriptionStyles}
          content={<>{description}</>}
          data-testid="errorPanelDescription"
        />
      )}
    </Flex>
  );
}

export default ErrorPanel;
